module.exports = __webpack_public_path__ + "img/msu.38402c29.webp";